import querystring from 'querystring'

import _ from 'lodash'
import { createAction } from 'redux-actions'
import queryString from 'query-string'
import log from 'sentry/log'

import { actionCreators as api } from 'reduxBits/api'

export const REQUEST_PARAMETERS = 'Send an async param request to server'
export const RECEIVE_PARAMETERS = 'Update the state with the fetched param information'
export const REQUEST_ACTIVE_PARAMETERS = 'Request all the active parameters'
export const RECEIVE_ACTIVE_PARAMETERS = 'Receive all the active parameters'
export const UPDATE = 'Update some data in the searchParams store'
export const NO_UPDATE_PARAMETERS = 'No update of parameters'
export const SET_DECIDING_KEYS = 'Set the deciding keys'
export const CATEGORY_LINK_CLICKED = 'Category link clicked'

const update = createAction(UPDATE)
const requestParameters = createAction(REQUEST_PARAMETERS)
const receiveParameters = createAction(RECEIVE_PARAMETERS)
const requestActiveParameters = createAction(REQUEST_ACTIVE_PARAMETERS)
const receiveActiveParameters = createAction(RECEIVE_ACTIVE_PARAMETERS)
const setDecidingKeys = createAction(SET_DECIDING_KEYS)
const categoryLinkClicked = createAction(CATEGORY_LINK_CLICKED)

const getLocation = (getState) => getState().router.location
const getQuery = (getState) => queryString.parse(_.get(getLocation(getState), 'search', {}))

const fetchParameters = () => async (dispatch) => {
  let parameters = []
  let activeParameters = []
  let dataGroups = {}
  let decidingKeys = []

  dispatch(requestParameters())

  const parametersFetch = dispatch(api.legacyApiFetch('blocket/v6/parameters/parameter_map'))
  const dataGroupsFetch = dispatch(api.legacyApiFetch('blocket/v6/parameters/data_group_map'))
  const activeParametersFetch = dispatch(
    api.legacyApiFetch('blocket/v6/parameters/active?context=search'),
  )
  const decidingKeysFetch = dispatch(
    api.legacyApiFetch('blocket/v6/parameters/deciding_keys?context=search'),
  )

  try {
    ;[{ parameters }, { dataGroups }, { activeParameters }, { decidingKeys }] = await Promise.all([
      parametersFetch,
      dataGroupsFetch,
      activeParametersFetch,
      decidingKeysFetch,
    ])
  } catch (error) {
    log.error(error)
    dispatch(receiveParameters(error))
    return
  }

  _.forEach(parameters, (parameter) => {
    if (parameter.rangeStart && parameter.rangeEnd) {
      parameter.rangeStart.items = dataGroups[_.camelCase(parameter.rangeStart.dataGroup)].items
      parameter.rangeEnd.items = dataGroups[_.camelCase(parameter.rangeEnd.dataGroup)].items

      if (parameter.rangeStart.dataGroupOrder) {
        parameter.rangeStart.items = parameter.dataGroupOrder.map(
          (dataIndex) => parameter.rangeStart.items[dataIndex],
        )
      }
      if (parameter.rangeEnd.dataGroupOrder) {
        parameter.rangeEnd.items = parameter.dataGroupOrder.map(
          (dataIndex) => parameter.rangeEnd.items[dataIndex],
        )
      }
    }

    if (parameter.dataGroup) {
      parameter.items = dataGroups[_.camelCase(parameter.dataGroup)].items

      if (parameter.dataGroupOrder) {
        parameter.items = parameter.dataGroupOrder.map((dataIndex) => parameter.items[dataIndex])
      }
    }
  })

  dispatch(receiveParameters(parameters))
  dispatch(
    receiveActiveParameters(
      activeParameters.map((parameter) => parameters[_.camelCase(parameter)]),
    ),
  )
  dispatch(setDecidingKeys(decidingKeys))
}

const updateActiveParameters = () => async (dispatch, getState) => {
  let activeParameters = []
  const debouncedFetching = _.debounce(() => dispatch(requestActiveParameters()), 1000)

  debouncedFetching()
  const query = encodeURIComponent(querystring.stringify(getQuery(getState)))
  const url = `blocket/v6/parameters/active?context=search&qs=${query}`

  try {
    ;({ activeParameters } = await dispatch(api.legacyApiFetch(url)))
    debouncedFetching.cancel()
  } catch (error) {
    log.error(error)
    debouncedFetching.cancel()
    dispatch(receiveActiveParameters(error))
    return
  }

  const { parameters } = getState().searchParams

  dispatch(
    receiveActiveParameters(
      activeParameters.map((parameter) => parameters[_.camelCase(parameter)]),
    ),
  )
}

export const actionCreators = {
  update,
  fetchParameters,
  updateActiveParameters,
  categoryLinkClicked,
}
